/**
 * NavigationServiceSetup
 * 
 * This component initializes the navigation service with React Router's navigate function.
 * Must be rendered inside BrowserRouter to have access to useNavigate.
 * 
 * Place this component early in the app tree, inside the Router but before routes.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "tools/navigationService";

function NavigationServiceSetup({ children }) {
  const navigate = useNavigate();
  
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  
  return children || null;
}

export default NavigationServiceSetup;
